<template>
  <div class="container sv052">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <RepaymentSimulation :member="false">
      <template v-if="isWebView" #entryBtn>
        <BtnMain class="-main" href="/entry/agreement">
          新規お申し込みはこちら
        </BtnMain>
      </template>
      <template v-else #entryBtn>
        <BtnMain class="-main" router-name="en001">
          新規お申し込みはこちら
        </BtnMain>
      </template>
      <template #cardContents>
        <HeadingTwo>お申し込みに迷ったらこちら！</HeadingTwo>
        <div class="row _mb-md-120 _mb-sm-60">
          <CardLink
            class="col-md-6 _mb-sm-15"
            title="au PAY スマートローンとは？"
            src="sv/sv052/img01.jpg"
            router-name="sv002"
          >
            au PAY スマートローンの特徴をご紹介します。
          </CardLink>
          <CardLink
            class="col-md-6"
            title="いまさら聞けない！ローンの基礎知識"
            src="sv/sv052/img02.jpg"
            router-name="sv043"
          >
            ローン初心者の方に向けて、ローンに関する気になる疑問や不安にお答えします。
          </CardLink>
        </div>
      </template>
    </RepaymentSimulation>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import RepaymentSimulation from "@/components/simulation/RepaymentSimulation";
import HeadingTwo from "@/components/heading/HeadingTwo";
import CardLink from "@/components/card/CardLink";
import BtnMain from "@/components/button/BtnMain";
import { isWebView } from "@/utils/UserAgent";

export default {
  name: "Sv052",
  components: {
    BreadcrumbGroup,
    BtnMain,
    CardLink,
    HeadingTwo,
    RepaymentSimulation,
  },
  setup() {
    setMeta({
      title: "ご返済シミュレーション｜ご返済について",
      description:
        "お客さまに合った毎月のご返済プランがシミュレーションできます。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ご返済シュミレーション",
    });
    return {
      isWebView,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "ご返済について",
          routerName: "sv047",
        },
        {
          text: "ご返済シミュレーション",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
</style>
